<template>
  <header class="navbar">
    <router-link to="/">
      <img src="../assets/logo.jpg" alt="" class="logo" />
        v1.0.2
    </router-link>
    <nav class="link">
      <div
        class="nav-item"
        v-for="item in navlist"
        :key="item.name"
        :class="{ active: routerName == item.path }"
      >
        <router-link :to="item.path">{{ item.name }}</router-link>
      </div>
    </nav>
  </header>
</template>

<script>
export default {
  name: "nav-component",
  props: {
    routerName: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      navlist: [
        {
          name: "首页",
          path: "/",
        },
        {
          name: "使用说明",
          path: "/useinfo",
        },
        // {
        //   name: "API文档",
        //   path: "/apidocument",
        // },
        {
          name: "案例",
          path: "/examples",
        },
      ],
    };
  },
};
</script>

<style  scoped>
.navbar {
  position: relative;
  z-index: 20;
  height: 60px;
  background-color: #fff;
  box-sizing: border-box;
  border-bottom: 1px solid #eaecef;
  line-height: 60px;
}
.logo {
  cursor: pointer;
  height: 36px;
  min-width: 22px;
  margin-left: 20px;
  vertical-align: middle;
  /* overflow-clip-margin: content-box; */
  overflow: clip;
}
.link {
  white-space: nowrap;
  box-sizing: border-box;
  display: flex;
  position: absolute;
  right: 50px;
  top: 0;
  height: 40px;
  font-size: 15px;
}
.links .nav-item:first-child {
  margin-left: 0;
}
.nav-item {
  display: inline-block;
  margin-left: 20px;
  cursor: pointer;
}
.active {
  margin-bottom: -2px;
  border-bottom: 2px solid #46bd87;
}
</style>>